import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { SelectBlockOption } from "../../types";

import searchIcon from "../../assets/img/search.png";

import "../../assets/styles/SearchSelectBlock.scss";
import SelectBlockElement from "./SelectBlockElement";

export interface SearchSelectBlockProps {
  search?: boolean;
  data: SelectBlockOption[];
  toggleAction(index: number): void;
  children?: React.ReactNode;
}

export interface SearchSelectBlockState {}

const CustomScrollbars = (props: {
  style: React.CSSProperties;
  children: React.ReactNode;
}) => {
  return (
    <Scrollbars
      thumbSize={30}
      renderTrackVertical={(props) => (
        <div {...props} className="track-vertical" />
      )}
      renderThumbVertical={(props) => (
        <div {...props} className="thumb-vertical" />
      )}
      style={props.style}
    >
      {props.children}
    </Scrollbars>
  );
};

export const SearchSelectBlock = (props: SearchSelectBlockProps) => {
  const [searchPhrase, setSearchPhrase] = useState("");
  const { search, data, toggleAction } = props;
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchPhrase(e.target.value);
  };
  return (
    <div className="search-select-block mb-5">
      {search && (
        <div className="search-bar">
          <input
            onChange={onSearch}
            type="text"
            value={searchPhrase}
            placeholder="wyszukaj"
          />
          {searchPhrase.length === 0 ? (
            <img className="search-icon" src={searchIcon} alt="search" />
          ) : (
            <div className="mark close" onClick={() => setSearchPhrase("")} />
          )}
        </div>
      )}
      <div className="content-wrapper d-flex">
        <CustomScrollbars style={{ height: 380 }}>
          <div className="content">
            {data.map((item, index) => {
              if (searchPhrase.length > 0) {
                if (
                  item.name
                    .toLowerCase()
                    .indexOf(searchPhrase.toLowerCase()) !== -1
                ) {
                  return (
                    <SelectBlockElement
                      index={index}
                      key={item.name}
                      element={item}
                      toggleAction={toggleAction}
                    />
                  );
                } else {
                  return null;
                }
              } else {
                return (
                  <SelectBlockElement
                    index={index}
                    key={item.name}
                    element={item}
                    toggleAction={toggleAction}
                  />
                );
              }
            })}
            {props.children && props.children}
          </div>
        </CustomScrollbars>
      </div>
    </div>
  );
};

export default SearchSelectBlock;
